export default "__VITE_ASSET__BcAJYDC9__"